// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"336de810","264":"2b5c081b","782":"38f7b0d1"}[chunkId] + ".chunk.js";
};